module.exports = __webpack_public_path__ + "static/media/Locana.dd788111.svg";